import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { ViewingsDispatchRequest } from "@/schemas";
import { AlertTriangle } from "lucide-react";
import { FormattedMessage, useIntl } from "react-intl";

const RESPONSE_PENDING_STATUSES = ["contacted", "suggested"];

export function shouldShowWaitingOver48hAlert(
  request: ViewingsDispatchRequest,
) {
  return (
    request.flags.waitingOver48h &&
    RESPONSE_PENDING_STATUSES.includes(request.lifecycleStatus)
  );
}

export function WaitingOver48hAlertIndicator({
  className = "",
}: {
  className?: string;
}) {
  const intl = useIntl();
  const label = intl.formatMessage({
    id: "viewings.alert.waitingOver48h.label",
  });

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            aria-label={`${label} alert`}
            tabIndex={0}
            className={`inline-flex text-categories-bright-orange-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-categories-bright-orange-700 ${className}`}
          >
            <AlertTriangle className="h-4 w-4" aria-hidden="true" />
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-64 text-xs">
          <FormattedMessage id="viewings.alert.waitingOver48h.tooltip" />
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export function WaitingOver48hAlertSection() {
  return (
    <section
      data-testid="waiting-over-48h-alert"
      className="rounded-md border border-alert-warning-300 bg-alert-warning-100 p-3 text-alert-warning-900"
    >
      <div className="flex items-start gap-2.5">
        <WaitingOver48hAlertIndicator className="mt-0.5" />
        <div>
          <h3 className="text-sm font-semibold leading-5">
            <FormattedMessage id="viewings.alert.waitingOver48h.label" />
          </h3>
          <p className="mt-0.5 text-sm leading-5">
            <FormattedMessage id="viewings.alert.waitingOver48h.tooltip" />
          </p>
        </div>
      </div>
    </section>
  );
}
